


































































































































import { defineComponent, PropType } from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccStar from "@/components/Atoms/OccStar/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import { formatDate } from "@/helpers/date-helper";
import { ApiResponse, Order } from "@/api/types";

export interface Props {
  sponsoredEventEntryApplicants: ApiResponse.SponsoredEventEntryApplicant[];
}

export default defineComponent({
  name: "SponsoredEventEntryApplicantsTable",
  components: {
    OccLabel,
    OccButton,
    OccStar,
    ListTable
  },
  props: {
    sponsoredEventEntryApplicants: {
      type: Array as PropType<Props["sponsoredEventEntryApplicants"]>,
      default: () => []
    },
    selectedEventEntryUsers: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const getDisplayScheduleSpan = (start: string, end: string) => {
      if (start && end) {
        return `${formatDate(start)}〜${formatDate(end)}`;
      } else if (start) {
        return formatDate(start);
      } else {
        return formatDate(end);
      }
    };

    const onChangeOrder = (order: Order, headerIndex: number) => {
      emit("changeOrder", order, headerIndex);
    };

    return {
      formatDate,
      getDisplayScheduleSpan,
      onChangeOrder
    };
  }
});
